export const Permissions = {
  CompanyAdmin: "*",
  ActivitiesRead: "activities:read",
  ActivitiesReadAll: "activities:read_all",
  AssetGroupsWrite: "asset_groups:write",
  AssetGroupsRead: "asset_groups:read",
  AssetGroupsDelete: "asset_groups:delete",
  CalculatorResultsRead: "calculator_results:read",
  CalculatorResultsWrite: "calculator_results:write",
  CalculatorResultsDelete: "calculator_results:delete",
  CustomAttributeDefinitionRead: "custom_attribute_definition:read",
  CustomAttributeDefinitionWrite: "custom_attribute_definition:write",
  CustomAttributeDefinitionDelete: "custom_attribute_definition:delete",
  CommentsRead: "comments:read",
  CommentsWrite: "comments:write",
  CommentsEdit: "comments:edit",
  CommentsDeleteAdmin: "comments:delete_admin",
  CompanyCustomReportsRead: "company_custom_reports:read",
  CompanyCustomReportsWrite: "company_custom_reports:write",
  CompanyCustomReportsDelete: "company_custom_reports:delete",
  CompanyUnitConfigRead: "company_unit_config:read",
  CompanyUnitConfigWrite: "company_unit_config:write",
  CompanyUnitConfigDelete: "company_unit_config:delete",
  DashboardsRead: "dashboards:read",
  DashboardsWrite: "dashboards:write",
  DashboardsDelete: "dashboards:delete",
  DataSubmissionRead: "data_submissions:read",
  DevicesRead: "devices:read",
  DevicesWrite: "devices:write",
  DevicesDelete: "devices:delete",
  EmissionsRead: "emissions:read",
  EmissionsWrite: "emissions:write",
  EmissionsDelete: "emissions:delete",
  EquipmentRead: "equipment:read",
  EquipmentWrite: "equipment:write",
  EquipmentDelete: "equipment:delete",
  EstimationMethodsRead: "estimation_methods:read",
  EstimationMethodsWrite: "estimation_methods:write",
  EstimationMethodsDelete: "estimation_methods:delete",
  EventSchemasRead: "event_schemas:read",
  EventSchemasWrite: "event_schemas:write",
  EventSchemasDelete: "event_schemas:delete",
  EventsRead: "events:read",
  EventsWrite: "events:write",
  EventsDelete: "events:delete",
  FacilitiesRead: "facilities:read",
  FacilitiesWrite: "facilities:write",
  FacilitiesDelete: "facilities:delete",
  FlowsRead: "flows:read",
  FlowsWrite: "flows:write",
  FlowsDelete: "flows:delete",
  FormCategoriesRead: "form_categories:read",
  FormCategoriesWrite: "form_categories:write",
  FormCategoriesDelete: "form_categories:delete",
  FormSchemasRead: "form_schemas:read",
  FormSchemasWrite: "form_schemas:write",
  FormSchemasDelete: "form_schemas:delete",
  FormSubmissionsRead: "form_submissions:read",
  FormSubmissionsWrite: "form_submissions:write",
  FormSubmissionsEdit: "form_submissions:edit",
  FormSubmissionsDelete: "form_submissions:delete",
  UserGroupCategoriesRead: "user_group_categories:read",
  UserGroupCategoriesWrite: "user_group_categories:write",
  UserGroupCategoriesDelete: "user_group_categories:delete",
  UserGroupsRead: "user_groups:read",
  UserGroupsWrite: "user_groups:write",
  UserGroupsDelete: "user_groups:delete",
  InsightsDashboardsRead: "insights_dashboards:read",
  InsightsDashboardsWrite: "insights_dashboards:write",
  JobsRead: "jobs:read",
  LedgerRead: "ledger:read",
  LedgerWrite: "ledger:write",
  LedgerDelete: "ledger:delete",
  LegacyInsights: "core:insights",
  LegacyDashboards: "core:dashboard",
  MeasurementsRead: "measurements:read",
  MeasurementsWrite: "measurements:write",
  MeasurementsDelete: "measurements:delete",
  NetworksRead: "networks:read",
  NetworksWrite: "networks:write",
  NetworksDelete: "networks:delete",
  ReportsRead: "reports:read",
  ReportsWrite: "reports:write",
  ReportsDelete: "reports:delete",
  ReportsLock: "reports:lock",
  ReportingGroupsRead: "reporting_groups:read",
  ReportingGroupsWrite: "reporting_groups:write",
  ReportingGroupsDelete: "reporting_groups:delete",
  RecordsRead: "records:read",
  RecordsWrite: "records:write",
  RecordsDelete: "records:delete",
  RecordsLock: "records:lock",
  RolesWrite: "roles:write",
  RolesDelete: "roles:delete",
  TemplatedConfigurationRunsRead: "templated_configuration_runs:read",
  TemplatedConfigurationRunsWrite: "templated_configuration_runs:write",
  UserInterfaceConfigurationsRead: "user_interface_configurations:read",
  UserInterfaceConfigurationsWrite: "user_interface_configurations:write",
  UserInterfaceConfigurationsDelete: "user_interface_configurations:delete",
  UsersWrite: "users:write",
  UsersDelete: "users:delete",
  VolumetricReportingRead: "volumetric_reporting:read",
  WorkflowTemplatesRead: "workflow_templates:read",
  WorkflowTemplatesWrite: "workflow_templates:write",
  WorkflowTemplatesDelete: "workflow_templates:delete",
  WorkflowsRead: "workflows:read",
  WorkflowsWrite: "workflows:write",
  WorkflowsDelete: "workflows:delete",
  WorkflowTasksRead: "workflow_tasks:read",
  WorkflowTasksWrite: "workflow_tasks:write",
  WorkflowTasksAssign: "workflow_tasks:assign",
  WorkflowTasksDelete: "workflow_tasks:delete",
  WorkerRead: "worker:read",
  WorkerWrite: "worker:write",
  WorkerDelete: "worker:delete",
  WorkerRunRead: "worker_run:read",
  WorkerRunWrite: "worker_run:write",
  WorkerRunDelete: "worker_run:delete",
  InvestigationsWrite: "investigations:write",
  StratosWriteActions: "stratos:write_actions",
  AmmoniaAccess: "ammonia:access",
  AmmoniaRead: "ammonia:read",
  AmmoniaLock: "ammonia:lock",
  AmmoniaApprove: "ammonia:approve",
  AmmoniaCalc: "ammonia:calc",
  AmmoniaWrite: "ammonia:write",
} as const;
